module.exports = __webpack_public_path__ + "img/link_icon.6b2a3b8b.png";